






import { getPositionWithFallback } from "../../../../utils/getPositionWithFallback";
import { useState, useEffect ,useRef } from "react";
import { useFormik } from "formik";
import {
  Drawer,
  Box,
  IconButton,
  Button,
  CircularProgress
} from "@mui/material";
import { useTranslation } from "react-i18next";
import profilecross from "../../../../assets/profilecross.svg";
import CustomText, { textStyles } from "../../../../components/CustomText";
import { MapContainer, TileLayer, Marker, Circle, useMap, useMapEvents } from "react-leaflet";
 import CloseIcon from "@mui/icons-material/Close";
import "leaflet/dist/leaflet.css";
import MultiSelectDropdown from "../../../../components/MultiSelectionDropdown";
import { BASE_URL } from "../../../../components/BaseUrl";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../../Utlis/Encryption";
import document1 from "../../../../assets/document1.svg"; // pdf icon
import CustomButton from "../../../../components/CustomButton";
import {toast,Toaster} from "react-hot-toast";
 import maparrow from "../../../../assets/maparrow.svg";
 import TaskLocation from "./TaskLocation";
 import LocationPermissionModal from "../../../../components/PermissionModal";
 import WorkersMultiSelectDropdown from "../../../../components/workersMultiSelection";
import { styled } from "@mui/system";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Webcam from "react-webcam";
import { convertLocalDateTimeToUTC } from "../../../../components/dateTimeUtils";
const RecenterMap = ({ lat, lng }) => {
  const map = useMap();
  map.setView([lat, lng]);
  return null;
};

// Define a custom styled TextField component within the same file
const CustomTextField = styled(TextField)(({ theme }) => ({
  width: "100%",
  "& .MuiInputBase-root": {
    fontSize: "12px",       // input text font size
    height: "40px",         // height of the input field
    padding: "0 12px",      // padding for input field
    borderRadius: "12px",   // border radius
  },
  "& .MuiInputBase-input": {
    fontSize: "12px",       // font size for input text
    padding: "8px 0",       // padding inside input text field
    height: "24px",         // height of input text
    lineHeight: "24px",     // line height of input text
  },
  "& .MuiInputBase-input::placeholder": {
    fontSize: "12px",       // font size for placeholder
    color: "#666",          // color for placeholder
    opacity: 1,             // full opacity for placeholder
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#999",    // border color for outline
    borderRadius: "12px",   // border radius
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#666",    // border color on hover
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#1976d2", // border color on focus
    borderRadius: "12px",   // maintain border radius on focus
  },
  "& .MuiInputLabel-root": {
    display: "none",        // hide label if not needed
  },
}));
const AddTask = ({ open, onClose , onTaskCreated }) => {
  const { t } = useTranslation();
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
const [loading, setLoading] = useState(false);
const priorityOptions = [
  { label: t("priorityOptions.low"), value: "low" },
  { label: t("priorityOptions.medium"), value: "medium" },
  { label: t("priorityOptions.high"), value: "high" },
  { label: t("priorityOptions.urgent"), value: "urgent" },
];
  const [workers, setWorkers] = useState([]);
  const [locationAllowed, setLocationAllowed] = useState(null);
const [openCamera, setOpenCamera] = useState(false);
const webcamRef = useRef(null);
  const getInitialFormValues = () => ({
  name: "",
  workers: [],
  startDate: "",
  endDate: "",
  startTime: "",
  endTime: "",
  description: "",
  priority: "",
  faceRestriction: true,
  locationRestriction: true,
  location: { lat: 40.4168, lng: -3.7038 },
  radius: 999,
  attachments: []
});

  const startRef = useRef(null);
  const endRef = useRef(null);
const [uploadedFile, setUploadedFile] = useState(null);
const { company } = useSelector((state) => state.auth);
const companyId = company?.id;
console.log(companyId)

const toAmPm = (time24) => {
  if (!time24) return "";
  const [h = "0", m = "00"] = time24.split(":");
  const hour = Number(h);
  const suffix = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${hour12}:${m} ${suffix}`;
};

/**
 * Combines native date + time inputs into a Date using the browser's local timezone
 * (same rules as `new Date` for ISO strings without Z). Use this for UTC conversion
 * so "8:27 PM" on the picker is exactly that wall time on this machine.
 */
const localDateTimeFromParts = (dateStr, timeStr) => {
  if (!dateStr?.trim() || !timeStr?.trim()) return null;
  const t = timeStr.trim();
  const isoLocal = /^\d{2}:\d{2}:\d{2}/.test(t)
    ? `${dateStr}T${t}`
    : `${dateStr}T${t}:00`;
  const d = new Date(isoLocal);
  return Number.isNaN(d.getTime()) ? null : d;
};

  const formik = useFormik({
    initialValues: getInitialFormValues(),
    validate: (values) => {
      const errors = {};
      
      // Task Name
      if (!values.name || values.name.trim() === "") {
        errors.name = t("taskAddModal.validation.taskNameRequired") || "Task name is required";
      }
      
      // Priority
      if (!values.priority || values.priority.trim() === "") {
        errors.priority = t("taskAddModal.validation.priorityRequired") || "Priority is required";
      }
      
      // Workers (must have at least one)
      if (!Array.isArray(values.workers) || values.workers.length === 0) {
        errors.workers = t("taskAddModal.validation.workersRequired") || "At least one worker must be assigned";
      }
      
      // Start Date
      if (!values.startDate || values.startDate.trim() === "") {
        errors.startDate = t("taskAddModal.validation.startDateRequired") || "Start date is required";
      }
      
      // End Date
      if (!values.endDate || values.endDate.trim() === "") {
        errors.endDate = t("taskAddModal.validation.endDateRequired") || "End date is required";
      }
      
      // Start Time
      if (!values.startTime || values.startTime.trim() === "") {
        errors.startTime = t("taskAddModal.validation.startTimeRequired") || "Start time is required";
      }
      
      // End Time
      if (!values.endTime || values.endTime.trim() === "") {
        errors.endTime = t("taskAddModal.validation.endTimeRequired") || "End time is required";
      }
      
      // Validate date/time logic (same local instant as submit → UTC)
      if (values.startDate && values.endDate && values.startTime && values.endTime) {
        const start = localDateTimeFromParts(values.startDate, values.startTime);
        const end = localDateTimeFromParts(values.endDate, values.endTime);
        if (start && end && end <= start) {
          errors.endTime =
            t("taskAddModal.validation.endTimeAfterStart") ||
            "End date & time must be after start date & time";
        }
      }
      
      return errors;
    },
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: async (values) => {
      setLoading(true);
      
      const start = localDateTimeFromParts(values.startDate, values.startTime);
      const end = localDateTimeFromParts(values.endDate, values.endTime);
      const startAtUTC = convertLocalDateTimeToUTC(start);
      const endAtUTC = convertLocalDateTimeToUTC(end);
      // Additional validation check
      if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
        toast.error(t("taskAddModal.validation.invalidDateTime") || "Please select valid start and end date/time");
        setLoading(false);
        return;
      }

      if (end <= start) {
        toast.error(t("taskAddModal.validation.endTimeAfterStart") || "Ending date & time must be after starting date & time");
        setLoading(false);
        return;
      }

      if (!startAtUTC || !endAtUTC) {
        toast.error(t("taskAddModal.validation.invalidDateTime") || "Please select valid start and end date/time");
        setLoading(false);
        return;
      }

      const body = {
        title: values.name,
        description: values.description,
        priority: values.priority || null,
        start_at: startAtUTC,
        end_at: endAtUTC,

        location: {
          address: values.location.address || "",
          lat: values.location.lat,
          lng: values.location.lng,
          radius_m: Number(values.radius),
        },
        assignees: values.workers,
        attachments: values.attachments || [],
        face_required: true,
        location_required: true,
        evidence_required: true,
        completion_policy: "all",
        meta: {
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          allow_decline: true,
          allow_reschedule: true,
        },
      };

      console.log("[AddTask] request payload & times", {
        pickedLocal: {
          start: `${values.startDate} ${values.startTime} (${toAmPm(values.startTime)})`,
          end: `${values.endDate} ${values.endTime} (${toAmPm(values.endTime)})`,
        },
        browserLocalInstant: {
          start: start?.toString(),
          end: end?.toString(),
        },
        sentToApiUtc: { start_at: body.start_at, end_at: body.end_at },
        deviceTimeZone: body.meta.timezone,
        fullPayload: body,
      });

      try {
        const res = await fetch(`${BASE_URL}/task-management/admin/tasks`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${decryptedToken}`,
          },
          body: JSON.stringify(body),
        });

        const data = await res.json();
        console.log("✅ Task Created:", data);
        
        if (onTaskCreated) onTaskCreated();

        if (res.ok && !data.error) {
          toast.success(t("taskAddModal.toast.taskCreated"));
          setTimeout(() => {
            onClose(); // close drawer after 1 sec
          }, 1000);
        } else {
          toast.error(data?.message || t("taskAddModal.toast.taskCreateFailed"));
        }
      } catch (err) {
        console.error("❌ Error creating task:", err);
        toast.error(t("taskAddModal.toast.taskCreateError"));
      } finally {
        setLoading(false);
      }
    },
  });

useEffect(() => {
  if (open) {
    formik.resetForm();
    setUploadedFile(null);
  }
}, [open]);

  // ✅ Fetch workers
  const fetchWorkers = async () => {
    try {
      const res = await fetch(`${BASE_URL}/public/workers?no_pagination=true&company_id=${companyId}&status=active`, {
        headers: { Authorization: `Bearer ${decryptedToken}` },
      });
      if (!res.ok) throw new Error("Failed to fetch workers");
      const data = await res.json();
  setWorkers(
  (data?.data?.records || []).map((w) => ({
           label: `${w.first_name} ${w.last_name}`, // Display name
        value: w.id, // ID sent in API
        email: w.email, // Store email for future use
        fullLabel: `${w.first_name} ${w.last_name}\n${w.email}`, 
  }))
);
    } catch (err) {
      console.error("Error fetching workers:", err);
    }
  };

  useEffect(() => {
    fetchWorkers();
  }, []);

  // ✅ Detect current location
  useEffect(() => {
    if (navigator.geolocation) {
      getPositionWithFallback(
        (pos) => {
          formik.setFieldValue("location", {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          });
        },
        (err) => console.warn("Geolocation blocked, fallback", err)
      );
    }
  }, []);

  const fetchAddress = async (lat, lng) => {
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
    );
    const data = await res.json();
    return data?.display_name || "";
  } catch (err) {
    console.error("❌ Error fetching address:", err);
    return "";
  }
};

const LocationMarker = ({ formik }) => {
  useMapEvents({
    click: async (e) => {
      const { lat, lng } = e.latlng;
      const address = await fetchAddress(lat, lng);
      formik.setFieldValue("location", { lat, lng, address });   // ✅ store address
    },
  });

  return (
    <Marker
      position={[formik.values.location.lat, formik.values.location.lng]}
      draggable={true}
      eventHandlers={{
        dragend: async (e) => {
          const latlng = e.target.getLatLng();
          const address = await fetchAddress(latlng.lat, latlng.lng);
          formik.setFieldValue("location", { lat: latlng.lat, lng: latlng.lng, address });
        },
      }}
    />
  );
};

 // store file response
const [uploading, setUploading] = useState(false);
  const [isFullMapOpen, setIsFullMapOpen] = useState(false);


  const handleFileUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  console.log("📌 Selected file:", file);

  const isPdf = file.type === "application/pdf";
  const uploadKey = isPdf ? "pdf" : "image";
  const uploadUrl = isPdf
    ? `${BASE_URL}/upload/pdf`
    : `${BASE_URL}/upload/image`;

  const formData = new FormData();
  formData.append(uploadKey, file);

  setUploading(true);

  try {
    console.log(`📤 Uploading ${isPdf ? "PDF" : "image"} to:`, uploadUrl);

    const res = await fetch(uploadUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${decryptedToken}`,
      },
      body: formData,
    });

    const data = await res.json();
    console.log("📥 Server response:", data);

    if (!res.ok) throw new Error(data?.message || "Upload failed");

    toast.success(`${isPdf ? "PDF" : "Image"} uploaded ✅`);

    const fileUrl = data?.data?.url || data?.url || data?.path || "";
    console.log("✅ Uploaded file URL:", fileUrl);

    // Set uploaded file preview and form values
    setUploadedFile({
      name: file.name,
      url: fileUrl,
      size: file.size,
      type: file.type,
    });

    formik.setFieldValue("attachments", [fileUrl]);
  } catch (err) {
    console.error("❌ Upload failed:", err);
    toast.error(err.message || "Upload failed");
  } finally {
    setUploading(false);
  }
};



const capturePhoto = async () => {
  const imageSrc = webcamRef.current.getScreenshot();
  if (!imageSrc) return;

  // Convert base64 to blob
  const blob = await fetch(imageSrc).then(res => res.blob());

  const file = new File([blob], `camera_${Date.now()}.jpg`, {
    type: "image/jpeg"
  });

  // Fake event so we can reuse handleFileUpload
  const fakeEvent = {
    target: {
      files: [file]
    }
  };

  setOpenCamera(false);
  handleFileUpload(fakeEvent);
};



const [showPermissionModal, setShowPermissionModal] = useState(false)

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: 500, maxWidth: "100%", overflow: "hidden" } }}
    >
      {/* Header */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "#E7EBEE",
          p: 1.3,
          borderBottom: "1px solid #E0E0E0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.2 }}>
          <IconButton onClick={onClose}>
            <img src={profilecross} alt="close" />
          </IconButton>
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 20,
              fontWeight: 600,
              color: "#2C384C",
            }}
          >
{t("taskAddModal.createTask")}          </CustomText>
        </Box>
      </Box>

      {/* Body */}
      <Box sx={{ p: 2, overflowY: "auto", flexGrow: 1 }}>
        <Box display="flex" gap={2} mb={1}>
   <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <label className="field_label" style={{marginBottom:"3px"}}>{t("taskAddModal.taskName")}<span className="red_asterisk">*</span></label>
            <input
              type="text"
              name="name"
              className="project_input"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              style={{
                height:"40px",
                border: formik.touched.name && formik.errors.name
                  ? "2px solid #d32f2f"
                  : "2px solid #091E4224"
              }}
            />
            {formik.touched.name && formik.errors.name && (
              <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                {formik.errors.name}
              </span>
            )}
          </Box>
</Box>
        {/* Task Name + Workers */}
        <Box display="flex"  alignItems='center' gap={2} mb={1}>
       
            <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
    
<MultiSelectDropdown
isSingleSelect={true}
  label={<>{t("taskAddModal.priority")} <span className="red_asterisk">*</span></>}
  name="priority"
  values={formik.values.priority ? [formik.values.priority] : []} // ✅ empty array if none
  options={priorityOptions}
  onChange={(e) => {
    const selectedPriority = e.target.value[0] || "";
    formik.setFieldValue("priority", selectedPriority, true); // validate on value update
    formik.setFieldTouched("priority", true, false);
    if (selectedPriority) {
      formik.setFieldError("priority", undefined);
    }
  }}
/>
{formik.touched.priority && formik.errors.priority && (
  <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
    {formik.errors.priority}
  </span>
)}
          </Box>
    
        </Box>
              <Box sx={{ flex: 1, display: "flex", flexDirection: "column",mb:2,  }}>
 
<WorkersMultiSelectDropdown
  label={<>{t("taskAddModal.assigningWorkers")} <span className="red_asterisk">*</span></>}
  name="workers"
  values={formik.values.workers}
  options={workers}
  enableSearch={true}
  isSingleSelect={true}
  onChange={(e) => {
    const selectedWorkers = e.target.value;
    formik.setFieldValue("workers", selectedWorkers, true);
    formik.setFieldTouched("workers", true, false);
    if (Array.isArray(selectedWorkers) && selectedWorkers.length > 0) {
      formik.setFieldError("workers", undefined);
    }
  }}
/>
{formik.touched.workers && formik.errors.workers && (
  <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
    {formik.errors.workers}
  </span>
)}
          </Box>

{/* Row: Priority */}

       
        <Box display="flex" gap={2} mb={2}>
          <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <label className="field_label" >{t("taskAddModal.startingDate")}<span className="red_asterisk">*</span></label>
         
              <input
               ref={startRef}
                onClick={() => startRef.current?.showPicker()} 
    type="date"
    name="startDate"
    className="project_input"
    value={formik.values.startDate || ""}
    onChange={(e) => {
      let val = e.target.value;
      const parts = val.split("-");
      if (parts[0] && parts[0].length > 4) {
        parts[0] = parts[0].slice(0, 4); // limit year to 4 digits
        val = parts.join("-");
      }
      const validFormat = /^\d{0,4}(-\d{0,2}){0,2}$/;
      if (validFormat.test(val)) {
        formik.setFieldValue("startDate", val, true);
        formik.setFieldTouched("startDate", true, false);
        if (val) {
          formik.setFieldError("startDate", undefined);
        }
      }
    }}
    onBlur={formik.handleBlur}
    style={{ 
      height: "40px",
      border: formik.touched.startDate && formik.errors.startDate
        ? "2px solid #d32f2f"
        : "2px solid #091E4224"
    }}
  />
  {formik.touched.startDate && formik.errors.startDate && (
    <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
      {formik.errors.startDate}
    </span>
  )}

          </Box>
          <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <label className="field_label" >{t("taskAddModal.endingDate")}<span className="red_asterisk">*</span></label>
          
              <input
               ref={endRef}
                onClick={() => endRef.current?.showPicker()} 
    type="date"
    name="endDate"
    className="project_input"
    value={formik.values.endDate || ""}
    onChange={(e) => {
      let val = e.target.value;
      const parts = val.split("-");
      if (parts[0] && parts[0].length > 4) {
        parts[0] = parts[0].slice(0, 4);
        val = parts.join("-");
      }
      const validFormat = /^\d{0,4}(-\d{0,2}){0,2}$/;
      if (validFormat.test(val)) {
        formik.setFieldValue("endDate", val, true);
        formik.setFieldTouched("endDate", true, false);
        if (val) {
          formik.setFieldError("endDate", undefined);
        }
      }
    }}
    onBlur={formik.handleBlur}
    style={{ 
      height: "40px",
      border: formik.touched.endDate && formik.errors.endDate
        ? "2px solid #d32f2f"
        : "2px solid #091E4224"
    }}
  />
  {formik.touched.endDate && formik.errors.endDate && (
    <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
      {formik.errors.endDate}
    </span>
  )}
          </Box>
        </Box>

        <Box display="flex" gap={2} mb={2}>
          <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <label className="field_label" >{t("taskAddModal.startingTime")}<span className="red_asterisk">*</span></label>
            <input
              type="time"
              name="startTime"
              className="project_input"
              value={formik.values.startTime}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              style={{
                height:"40px",
                border: formik.touched.startTime && formik.errors.startTime
                  ? "2px solid #d32f2f"
                  : "2px solid #091E4224"
              }}
            />
            {formik.touched.startTime && formik.errors.startTime && (
              <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                {formik.errors.startTime}
              </span>
            )}
          </Box>
          <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <label className="field_label" >{t("taskAddModal.endingTime")} <span className="red_asterisk">*</span></label>
            <input
              type="time"
              name="endTime"
              className="project_input"
              value={formik.values.endTime}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              style={{
                height:"40px",
                border: formik.touched.endTime && formik.errors.endTime
                  ? "2px solid #d32f2f"
                  : "2px solid #091E4224"
              }}
            />
            {formik.touched.endTime && formik.errors.endTime && (
              <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                {formik.errors.endTime}
              </span>
            )}
          </Box>
        </Box>












        {/* Description */}
        <Box mb={2} display="flex" flexDirection="column">
          <label className="field_label" >{t("taskAddModal.description")}</label>
          <textarea
            name="description"
            rows={4}
            className="project_input"
            value={formik.values.description}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </Box>

<Box mb={2} display="flex" flexDirection="column">
  {/* <label className="field_label">
    {t("taskAddModal.supportingDocument")} 
  </label> */}
  <Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 1
  }}
>
  <label className="field_label">
    {t("taskAddModal.supportingDocument")}
  </label>

  <CustomText
    sx={{
      fontSize: 15,
      color: "#1976d2",
      cursor: "pointer",
      fontWeight: 500,
         fontFamily: 'Poppins, sans-serif',
    }}
onClick={() => setOpenCamera(true)}
  >
    {t("taskAddModal.takePhoto")}
  </CustomText>
</Box>

  {!uploadedFile ? (
    <Box
      sx={{
        border: "2px dashed #D0D5DD",
        borderRadius: 2,
        p: 3,
        textAlign: "center",
        backgroundColor: "#F9FAFB",
        cursor: "pointer",
        py: 6,
      }}
      onClick={() => document.getElementById("fileInput").click()}
    >
      {uploading ? (
        <CircularProgress size={20} />
      ) : (
        <span>{t("taskAddModal.dragFiles")}</span>
      )}
      <input
        id="fileInput"
        type="file"
        accept="application/pdf,image/*"
        style={{ display: "none" }}
        onChange={handleFileUpload}
      />
      <input
  id="cameraInput"
  type="file"
  accept="image/*"
  capture="environment"
  style={{ display: "none" }}
  onChange={handleFileUpload}
/>
    </Box>
  ) : (
    <Box
      sx={{
        border: "1px solid #ccc",
        borderRadius: "6px",
        padding: "10px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1,
        position: "relative",
      }}
    >
      {/* Cross Icon */}
      <IconButton
        size="small"
        onClick={() => {
          setUploadedFile(null);
          formik.setFieldValue("attachments", []);
        }}
        sx={{
          position: "absolute",
          top: 4,
          right: 4,
          backgroundColor: "#fff",
          border: "1px solid #E0E0E0",
          "&:hover": { backgroundColor: "#f5f5f5" },
        }}
      >
        <img src={profilecross} alt="remove" style={{ width: 16, height: 16 }} />
      </IconButton>

      {/* File Preview */}
{uploadedFile?.type === "application/pdf" && (
  <Box
    component="img"
    src={document1}
    alt="PDF file"
    sx={{ width: 45, height: 45, objectFit: "contain" }}
  />
)}

      {/* File Name */}
      <CustomText
        sx={{
          fontSize: 14,
          fontWeight: 500,
          color: "#172B4D",
          wordBreak: "break-word",
          textAlign: "center",
        }}
      >
        {uploadedFile.name}
      </CustomText>

      {/* File Size */}
      <CustomText
        sx={{
          fontSize: 12,
          fontWeight: 400,
          color: "#6B778C",
        }}
      >
        {(uploadedFile.size / (1024 * 1024)).toFixed(2)} MB
      </CustomText>
    </Box>
  )}
        <CustomText
        sx={{
          fontSize: 14,
          fontWeight: 500,
          color: "#172B4D",
          wordBreak: "break-word",
          textAlign: "left",
        }}
      >
        {t("upload.note")}
      </CustomText>
</Box>



{/* Face Scan Restriction — hidden; always sent as true in API */}
{/*
<Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
  <label className="field_label">{t("taskAddModal.faceRestriction")}</label>
  <Switch
    checked={formik.values.faceRestriction}
    onChange={(e) =>
      formik.setFieldValue("faceRestriction", e.target.checked)
    }
  />
</Box>
*/}

{/* Location Restriction — hidden; always sent as true in API */}
{/*
<Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
  <label className="field_label">{t("taskAddModal.locationRestriction")}</label>
  <Switch
    checked={formik.values.locationRestriction}
    onChange={(e) =>
      formik.setFieldValue("locationRestriction", e.target.checked)
    }
  />
</Box>
*/}

        {/* Radius input */}
        <Box mb={2} display="flex" flexDirection="column">
          <label className="field_label" >{t("taskAddModal.radius")}</label>
          <input
            type="number"
            name="radius"
            className="project_input"
            value={formik.values.radius}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            style={{height:"40px"}}
          />
        </Box>

<TaskLocation
  formValues={formik.values}
  setFormValues={(updater) => {
    if (typeof updater === 'function') {
      const newValues = updater(formik.values);
      Object.keys(newValues).forEach(key => {
        if (key === 'location') {
          formik.setFieldValue('location', newValues.location);
        } else {
          formik.setFieldValue(key, newValues[key]);
        }
      });
    } else {
      Object.keys(updater).forEach(key => {
        formik.setFieldValue(key, updater[key]);
      });
    }
  }}
  radius={formik.values.radius}
  onPermission={(allowed) => {
    setLocationAllowed(allowed);
    // Permission granted (e.g. re-enabled in the browser) - close the modal
    if (allowed) setShowPermissionModal(false);
  }}
/>

  <CustomButton
  size="small"
  onClick={() => {
    if (locationAllowed === false) {
      // 🚨 show permission modal instead of toast
      setShowPermissionModal(true);
      return;
    }
    formik.handleSubmit();
  }}
  label={loading ? (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <CircularProgress size={18} sx={{ color: "white" }} />
      {t("taskAddModal.save")}
    </Box>
  ) : (
    t("taskAddModal.save")
  )}
/>
      </Box>
      
<LocationPermissionModal
  open={showPermissionModal}
  onAllow={() => {
    setShowPermissionModal(false);
    setLocationAllowed(true);
  }}
  onCancel={() => {
    setShowPermissionModal(false);
    setLocationAllowed(false);
  }}
/>
  
  {openCamera && (
  <Box
    sx={{
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0,0,0,0.6)",
      zIndex: 2000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}
  >
    <Box
      sx={{
        background: "#fff",
        borderRadius: 2,
        p: 2,
        width: 360
      }}
    >
      <Webcam
        ref={webcamRef}
        audio={false}
        screenshotFormat="image/jpeg"
        videoConstraints={{
          facingMode: "environment"
        }}
        style={{ width: "100%", borderRadius: 8 }}
      />

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap:2,
          mt: 2
        }}
      >
        <Button
          variant="outlined"
          onClick={() => setOpenCamera(false)}
           sx={{   fontFamily: 'Poppins, sans-serif',textTransform:"capitalize"}}
        >
         {t("taskAddModal.camera.cancel")}
        </Button>

        <Button
          variant="contained"
          onClick={capturePhoto}
          sx={{   fontFamily: 'Poppins, sans-serif',textTransform:"capitalize"}}
        >
         {t("taskAddModal.camera.capture")}
        </Button>
      </Box>
    </Box>
  </Box>
)}


    </Drawer>
  );
};

export default AddTask;














